import { alertConstants } from '_constants';

function success(message) {
  return (dispatch) => {
    dispatch({ type: alertConstants.SUCCESS, message });
    setTimeout(() => {
      dispatch({ type: alertConstants.CLEAR });
    }, 7500);
  };
}

function error(err) {
  try {
    const errorObject = JSON.parse(err);
    return ({ type: alertConstants.FORM_ERROR, message: errorObject.message, errors: errorObject.errors });
  } catch (e) {
    return ({ type: alertConstants.ERROR, message: err });
  }
}

function clear() {
  return { type: alertConstants.CLEAR };
}

const alertActions = {
  success,
  error,
  clear
};

export default alertActions;
